import { Button, DialogFooter, DialogTitle } from "shared/components";
import { Loader2, RotateCcwIcon } from "lucide-react";

import { getText } from "shared/lib";

export interface PostReviewProposalContentProps {
  onClickCancel: () => void;
  onClickSubmit: () => void;
  submitting: boolean;
}

export function PostReviewProposalContent({
  onClickCancel,
  onClickSubmit,
  submitting,
}: PostReviewProposalContentProps) {
  return (
    <>
      <DialogTitle>{getText("Start again?")}</DialogTitle>

      <p className="text-textPrimary text-bodylg">
        {getText(
          "This will start a new proposal, beginning at entering an address.",
        )}
      </p>

      <DialogFooter>
        <Button onClick={onClickCancel} variant="outline">
          {getText("Cancel")}
        </Button>

        <Button className="gap-2" onClick={onClickSubmit} variant="default">
          {submitting ? (
            <Loader2 className="animate-spin" />
          ) : (
            <RotateCcwIcon className="h-4 w-4" />
          )}
          {getText("Restart")}
        </Button>
      </DialogFooter>
    </>
  );
}
